import React from 'react';
import { RouterConfig } from '../../config/router';
import { UnderOverMenu } from '../../components/UnderOverMenu';

const allPageTile = [
  {
    title: '6.5',
    over: RouterConfig.CornerOverSix,
    under: RouterConfig.CornerUnderSix,
  },
  {
    title: '7.5',
    over: RouterConfig.CornerOverSeven,
    under: RouterConfig.CornerUnderSeven,
  },
  {
    title: '8.5',
    over: RouterConfig.CornerOverEight,
    under: RouterConfig.CornerUnderEight,
  },
  {
    title: '9.5',
    over: RouterConfig.CornerOverNine,
    under: RouterConfig.CornerUnderNine,
  },
  {
    title: '10.5',
    over: RouterConfig.CornerOverTen,
    under: RouterConfig.CornerUnderTen,
  },
  {
    title: '11.5',
    over: RouterConfig.CornerOverEleven,
    under: RouterConfig.CornerUnderEleven,
  },
  {
    title: '12.5',
    over: RouterConfig.CornerOverTwelve,
    under: RouterConfig.CornerUnderTwelve,
  },
];

export default function CornersUnderOver() {
  return <UnderOverMenu menu={allPageTile} title="Wybór rożnych" />;
}
